export default __webpack_public_path__ + "static/media/Karnataka_1.fef306d4.png";